export const createLinksForEntities = (body, convertTagToLink, defaultCallback) => {
  const newBody = body
    .replace(/@\[[^\]]*\]\([^)]*\)/g, match => {
      return `,,${match},,`;
    })
    .split(',,')
    .map((result, idx) => {
      const matches = result.match(/@\[[^\]]*\]\([^)]*\)/);
      if (matches) {
        return convertTagToLink(matches[0], idx);
      } else {
        return defaultCallback(result);
      }
    });
  return newBody;
};
